import { render, staticRenderFns } from "./fldy.vue?vue&type=template&id=62aa78ef&scoped=true&"
import script from "./fldy.vue?vue&type=script&lang=js&"
export * from "./fldy.vue?vue&type=script&lang=js&"
import style0 from "./fldy.vue?vue&type=style&index=0&id=62aa78ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa78ef",
  null
  
)

export default component.exports